import * as t from "io-ts";
import nullable from "./nullable";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
export const scanKindT = t.union([
    t.literal("WEIGHBRIDGE"),
    t.literal("DELIVERY_NOTE"),
    t.literal("POD"),
    t.literal("OTHER"),
]);
export const scanReadingT = t.intersection([
    t.type({
        kind: scanKindT,
        relevant: t.boolean,
    }),
    t.partial({
        netWeightKg: nullable(t.string),
        grossWeightKg: nullable(t.string),
        tareWeightKg: nullable(t.string),
        cubicMeters: nullable(t.string),
        quantity: nullable(t.string),
        unit: nullable(t.string),
        ref: nullable(t.string),
        date: nullable(t.string),
        issuer: nullable(t.string),
        signedBy: nullable(t.string),
        notes: nullable(t.string),
        confidence: nullable(t.record(t.string, t.number)),
    }),
]);
export const cargoScanReadingT = t.strict({
    id: t.string,
    fileId: t.string,
    stopId: nullable(t.string),
    documentType: nullable(t.string),
    extracted: nullable(scanReadingT),
    applyError: nullable(t.string),
    createdAt: isoDateTimeForJSON,
});
export const cargoScanReadingsT = t.array(cargoScanReadingT);
//# sourceMappingURL=scan-readings.js.map